// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/upper-level-prog-charts.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/upper-level-prog-charts/upper-level-charts.js';
import g1 from '../lessons/meteorology/upper-level-prog-charts/upper-level-prog-charts.js';

mount([g0, g1]);
